import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '../BrandLogo';
import SeoHead from '../SeoHead';

export default function AuthShell({ title, subtitle, eyebrow, icon, children, centered = false }) {
  return (
    <div className="sba-auth-page">
      <SeoHead />
      <div className="sba-auth-card" style={centered ? { textAlign: 'center' } : undefined}>
        {icon && (
          <div className="sba-auth-icon-wrap">
            <span className="material-symbols-outlined" style={{ fontSize: 36 }}>
              {icon}
            </span>
          </div>
        )}
        {!icon && (
          <Link to="/" className="sba-auth-logo" style={centered ? { justifyContent: 'center' } : undefined}>
            <span className="sba-auth-logo-icon">
              <BrandLogo size={48} />
            </span>
            Success Bridge Academy
          </Link>
        )}
        {eyebrow && <p className="sba-auth-eyebrow">{eyebrow}</p>}
        {title && <h1 className="sba-auth-title">{title}</h1>}
        {subtitle && <p className="sba-auth-subtitle">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}
